module.exports = __webpack_public_path__ + "img/description_ui.e767828a.png";